module.exports = __webpack_public_path__ + "static/img/contant_2.596fef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/contant_2.jpg
// module id = w/2n
// module chunks = 0